import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-row justify-between items-center text-gray-700 mb-2" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "text-sm text-gray-500" }, " *You will need an authenticator app like Authy or Google Authenticator to use two factor. ", -1)
const _hoisted_3 = {
  key: 0,
  class: "border-t border-gray-300 mt-4"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "text-danger mt-4 text-sm" }, " Note: The information below will only be shown once. ", -1)
const _hoisted_5 = { class: "flex flex-row mt-4 mb-8" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "text-gray-700 text-sm mr-4 space-y-4" }, [
  /*#__PURE__*/_createVNode("p", null, " Two factor authentication is now enabled. Scan the following QR Code using your phone's authenticator application. "),
  /*#__PURE__*/_createVNode("p", null, " While two factor authentication is enabled, you will be prompted for a secure random token during authentication. You may retrieve this token from your phone's Google Authenticator app. ")
], -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "text-gray-700 text-sm mb-2" }, " Store these recovery codes in a secure password manager. They can be used to recover access to your account if your two factor authentication device is lost. ", -1)
const _hoisted_9 = { class: "flex flex-row justify-between text-gray-700 bg-gray-200 border border-gray-300 py-2 pl-8 pr-4" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ConfirmPasswordModal = _resolveComponent("ConfirmPasswordModal")
  const _component_Toggle = _resolveComponent("Toggle")
  const _component_SettingsLayout = _resolveComponent("SettingsLayout")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_ConfirmPasswordModal, {
      show: _ctx.showConfirmPasswordModal,
      "onUpdate:show": _cache[1] || (_cache[1] = $event => (_ctx.showConfirmPasswordModal = $event)),
      "onHandle-confirm": _cache[2] || (_cache[2] = $event => (_ctx.handleToggleClick(!_ctx.toggleState)))
    }, null, 8, ["show"]),
    _createVNode(_component_SettingsLayout, {
      title: "Two Factor Authentication",
      description: "Add additional security to your account by using two factor authentication"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("span", null, _toDisplayString(_ctx.toggleState ? 'Enabled' : 'Disabled'), 1),
          _createVNode(_component_Toggle, {
            value: _ctx.toggleState,
            "onHandle-click": _cache[3] || (_cache[3] = $event => (_ctx.handleToggleClick($event)))
          }, null, 8, ["value"])
        ]),
        _hoisted_2,
        (_ctx.qrCode.length)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _hoisted_4,
              _createVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode("div", { innerHTML: _ctx.qrCode }, null, 8, ["innerHTML"])
              ]),
              (_ctx.recoveryCodes.length)
                ? (_openBlock(), _createBlock("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode("div", _hoisted_9, [
                      (_openBlock(), _createBlock(_Fragment, null, _renderList([1, 2], (v, i) => {
                        return _createVNode("ul", { key: i }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList([..._ctx.recoveryCodes].splice(
								i * 4,
								v * 4
							), (code, index) => {
                            return (_openBlock(), _createBlock("li", {
                              class: "list-disc mb-2 text-sm",
                              key: index
                            }, _toDisplayString(code), 1))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      }), 64 /* STABLE_FRAGMENT */))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64 /* STABLE_FRAGMENT */))
}